import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { HelmetProvider } from "react-helmet-async"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import Router from "./routes"
import { useValidateAccessTokenFromUrl } from "./hooks/useValidateAccessTokenFromUrl"
import AuthorizingScreen from "./components/AuthorizingScreen"

function App() {
  console.log("Environment:", import.meta.env.VITE_ENV)
  const { isAuthorizing } = useValidateAccessTokenFromUrl()

  return (
    <HelmetProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      {isAuthorizing ? (
        <AuthorizingScreen />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Router />
        </LocalizationProvider>
      )}
    </HelmetProvider>
  )
}

export default App
